import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { AppUiActions } from '../../../store/actions';
import * as fromRoot from '../../../store/reducers';
import { TimerService } from './../../../services/timer.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'generic-page',
    template: require('./generic-page.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericPageComponent implements OnInit, OnDestroy {

    title: string;
    content: string;
    visible: boolean;
    genericPageDataSubscription: Subscription;

    constructor(
        private store: Store<fromRoot.State>,
        private changeDetectorRef: ChangeDetectorRef,
        private timerService: TimerService
    ) {}

    ngOnInit() {
        this.genericPageDataSubscription = this.store.select(fromRoot.getGenericPage).subscribe(genericPage => {
            this.title = genericPage.title;
            this.content = genericPage.content;
            this.visible = genericPage.visible;
            if (genericPage.redirectUrl) {
                setTimeout(() => { window.location.href = genericPage.redirectUrl; }, 1000);
            }
            if (genericPage.isNonRecoverable) {
                this.timerService.pauseTimer();
            }
            this.changeDetectorRef.markForCheck();
        });
    }

    ngOnDestroy() {
        this.genericPageDataSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/generic-page/generic-page.component.ts